import {
  CONSENT_UPDATED_EVENT,
  getStoredConsent,
  loadConsentManagedScripts,
} from "./src/utils/consent";

function currentPath(location) {
  if (!location) return "/";

  return `${location.pathname}${location.search}${location.hash}`;
}

export const onClientEntry = () => {
  window.addEventListener(CONSENT_UPDATED_EVENT, (event) => {
    loadConsentManagedScripts(event.detail, currentPath(window.location));
  });
};

export const onRouteUpdate = ({ location }) => {
  loadConsentManagedScripts(getStoredConsent(), currentPath(location));
};
